<template>
    <div class="container mx-auto page no-top-bar">
        <div class="mx-4 list-wrapper bg-white rounded-xl" v-if="listNotification.length > 0">
            <NotiItem
                class="bg-item bg-white border-a-gray-666666 border-opacity-10 border-b border-1"
                :class="{'bg-a-blue-0069a8 bg-opacity-10': !notiItem.isRead}"
                v-for="(notiItem) in listNotification"
                :key="notiItem.value"
                :notiItem="notiItem"
                @clickNotiItem="clickNoti($event)"
            ></NotiItem>
        </div>
    </div>

</template>
<script>
//component
import NotiItem from "./NotiItem.vue";
import { NotificationType } from "@/helper/StaticValue.js";
//service
import BzbsNotification from "@/core/noti/BzbsNotification.js";
import ConfigManager from '@/config/ConfigManager';

import Account from "@/helper/AccountHelper.js";

export default {
    name: 'notificationlist',
    components: {
        NotiItem,
    },
    props: {
        modalController:    { type: Object }
    },
    data: function () {
        return {
            listNotification: [],
            NotificationType: NotificationType,
        }
    },
    mounted: function () {
        this.getListNoti();
    },
    methods: {
        getListNoti: function () {

            return new Promise((resolve) => {
                BzbsNotification.apiGetNotification().subscribe({
                    next: (data) => {
                        console.log(data);
                        this.listNotification = data.sort((a, b) => b.createTime - a.createTime);
                        this.readAllNoti();
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        clickNoti: async function(notiItem) {
            if (!notiItem.isRead) {
                await this.postReadNoti(notiItem.rowKey);
            }

            this.handelNotiItem(notiItem);
        },
        readAllNoti: async function() {
            console.log(this.listNotification)
            for(let noti of this.listNotification){
                if (!noti.isRead) {
                    await this.postReadNoti(noti.rowKey);
                }
            }
        },
        postReadNoti: function (rowKey) {
            return new Promise((resolve) => {
                this.modalController.loadingModal.show();
                BzbsNotification.apiReadNotification(rowKey).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.modalController.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err);
                        this.modalController.loadingModal.hide();
                        resolve(false);
                    }
                });
            });
        },
        handelNotiItem: function (notiItem) {
            if (notiItem.objectType == NotificationType.Badge) {
                window.location.reload();
                // badge(bzbsNoti); //! Popup Badge ถ้าต้องทำ โปรเจคเก่าไม่ได้ทำไว้
            } else if (
                notiItem.objectType == NotificationType.Ads
                || notiItem.objectType == NotificationType.Campaign
                || notiItem.objectType == NotificationType.Event
                || notiItem.objectType == NotificationType.Media)
            {
                this.$router.push('/campaign/' + notiItem.id);
                return;

            } else if (notiItem.objectType == NotificationType.Cat) {
                let cateid = ConfigManager.getCateNoti();
                if (ConfigManager.getAgencyId() == notiItem.agencyId) {
                    switch (notiItem.id) {
                        case cateid.catActivityId:
                            this.$router.push('/activity');
                            break;
                        case cateid.catNewsId:
                            this.$router.push('/home');
                            break;
                        case cateid.catProductId:
                            this.$router.push('/home');
                            break;
                        case cateid.catPrivilegeId:
                            this.$router.push('/home');
                            break;
                        case cateid.catRewardId:
                            this.$router.push('/reward');
                            break;
                        default:
                            this.$router.push('/home');
                            break;
                    }
                } else {
                    this.$router.push('/home');
                }
                return;
            } else if (notiItem.objectType == NotificationType.Comment) {
                this.$router.push('/helpchat');
                //! Logic จากเว็บเก่า
                // if (notiItem.buzzKey.indexOf("f-") != 0) {
                //     this.$router.push('/helpchat');
                // } else {
                //     this.$router.push('/helpchat');
                // }
            } else if (notiItem.objectType == NotificationType.Content) {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg("ไม่รองรับการแจ้งเตือนประเภทนี้ โปรดติดต่อผู้ดูแล")
                    .show();
                this.modalController.alertModal.onClickClose(()=> {
                    window.location.reload();
                });
                return;
            } else if (notiItem.objectType == NotificationType.Link) {
                let url = notiItem.url || "";
                let token = Account.getToken();
                if (token) {
                    url = url.replace("<token>", token);
                }
                window.open(url, '_blank');
                window.location.reload();
                return;
            } else if (notiItem.objectType == NotificationType.Message) {

                this.modalController.alertModal
                    .clearModal()
                    .setMsg(notiItem.message)
                    .show();
                this.modalController.alertModal.onClickClose(()=> {
                    window.location.reload();
                });
                return;
            } else {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg("ไม่รองรับการแจ้งเตือนประเภทนี้ โปรดติดต่อผู้ดูแล")
                    .show();
                this.modalController.alertModal.onClickClose(()=> {
                    window.location.reload();
                });
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .list-wrapper {
        .bg-item {
            border-radius: 0;
        }
        .bg-item:first-child {
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }
        .bg-item:last-child {
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
        }
        .bg-notread {
            background: rgba(0, 105, 168, 0.5) #0069a8;
        }
    }
</style>
